import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import ServiceShowcase from '../components/ServiceShowcase';
import WhyChooseUs from '../components/WhyChooseUs';
import Testimonials from '../components/Testimonials';
import Stats from '../components/Stats';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import Chatbot from '../components/Chatbot';
import LimitedTimeOffer from '../components/LimitedTimeOffer';
import SEO from '../components/SEO';
import CRMShowcase from '../components/CRMShowcase';

const Home = () => {
  return (
    <div style={{ background: 'var(--bg-dark)' }}>
      <SEO title="Custom Web Development, Mobile Apps & AI Solutions in Buffalo NY" />
      <LimitedTimeOffer />
      <Header />
      <Hero />
      <About />
      <ServiceShowcase />
      <Services />
      <CRMShowcase />
      <WhyChooseUs />
      <Testimonials />
      <Stats />
      <Contact />
      <Footer />
      {/* Proactive chatbot - appears after 30 seconds */}
      <Chatbot proactiveDelay={30000} />
    </div>
  );
};

export default Home;
